export default __webpack_public_path__ + "static/media/coolspring-logowhite-23.834141ee.svg";